import styles from '../../../sass/components/ManageLayout.module.scss'
import {Link, usePage} from "@inertiajs/inertia-react";
import i18n from 'i18next';
import {useEffect, useState} from "react";
import {URLSearchParams} from "core-js/modules/web.url-search-params.constructor";

export function Manage({title, children, className}) {

    const [showMobileNav, setShowMobileNav] = useState(false);
    const features = usePage().props.features;
    const fromDashboard = new URLSearchParams(document.location.search).has('from_dashboard')

    const { billing_system } = usePage().props.auth.current_organization;
    const invoiceLinkIsDisplayed = (billing_system == 'easyTithe' && features['checkout']) || billing_system == 'UnityEcomm';
    const billingLinkIsDisplayed = (billing_system == 'Workday' && features['checkout']);

    const trialBannerIsDisplayed = usePage().props.auth.current_organization.is_admin && usePage().props.auth.current_organization.trial_count > 0;

    const isAdmin = usePage().props ? usePage().props.auth.current_organization?.is_admin : false;

    useEffect(() => {
        window.addEventListener('resize', handleBodyStyles);
        if (fromDashboard) {
            setShowMobileNav(true);
        }

        return () => {
            window.removeEventListener('resize', handleBodyStyles)
        }
    }, [])

    useEffect(() => {
        handleBodyStyles()

        return () => {
            setBodyStyles()
        }
    }, [showMobileNav]);

    function handleBodyStyles() {
        let matchMedia = window.matchMedia("(max-width: 875px)")
        if ((fromDashboard || showMobileNav) && matchMedia.matches) {
            setBodyStyles('fixed', '100%')
        } else {
            setBodyStyles()
        }
    }

    function setBodyStyles(position = '', width = '') {
        document.body.style.position = position
        document.body.style.width = width
    }

    return (
        <div className={className ? styles.manageWrap + " " + className : styles.manageWrap}>
            <div className={styles.sideBarWrap}>
                <section className={`${styles.sideBar} ${trialBannerIsDisplayed ? styles.withTrialBanner : ''}`}>
                    <Link className={styles.back} as="a" href={route('dashboard')}>
                        <span className={styles.backText}>
                            <i className="fa fa-chevron-left"></i><span>{i18n.t('manage.back')}</span>
                        </span>
                    </Link>
                    <h2 className={styles.sideBarTitle}>{i18n.t('manage.manage-organization')}</h2>
                    <nav className={styles.nav}>
                            <Link data-testid="manage-link-account_overview"
                                className={route().current('manage.account-overview') ? styles.active : ''}
                                href={route('manage.account-overview')}
                            >
                                {i18n.t('manage.account-overview')}
                            </Link>

                        {isAdmin &&
                            <Link data-testid="manage-link-subscriptions"
                                className={route().current('manage.subscriptions.index') ? styles.active : ''}
                                href={route('manage.subscriptions.index')}
                            >
                                {i18n.t('manage.subscriptions')}
                            </Link>
                        }

                        { invoiceLinkIsDisplayed &&
                            <Link data-testid="manage-link-invoice"
                                className={route().current('manage.invoice.index') ? styles.active : ''}
                                href={route('manage.invoice.index')}
                            >
                                {i18n.t('manage.invoices')}
                            </Link>
                        }

                        { isAdmin &&
                            billingLinkIsDisplayed &&
                            <Link data-testid="manage-link-billing"
                                className={route().current('manage.billing.index') ? styles.active : ''}
                                href={route('manage.billing.index')}
                            >
                                {i18n.t('manage.billing')}
                            </Link>
                        }


                        <Link data-testid={'manage-link-people'}
                            className={route().current('manage.people.index') ? styles.active : ''}
                            href={route('manage.people.index')}
                        >
                            {i18n.t('manage.people')}
                        </Link>
                    </nav>
                </section>
            </div>
            <section
                className={`${styles.mobileSideBar} ${showMobileNav ? styles.showMobile : ''} ${fromDashboard ? styles.fromDashboard : ''}`}>
                <div className={styles.mobileSideBarTitleWrap}>
                    <Link
                        href={route('dashboard')}
                        className={`btn btn-toolbar ${styles.mobileBackToDashboardIcon}`}
                    >
                        <i className={`fa fa-chevron-left`}></i>
                    </Link>
                    <h2 className={styles.mobileSideBarTitle}>{i18n.t('manage.manage-organization')}</h2>
                </div>
                <nav className={styles.mobileNav}>
                    <Link href={route('manage.account-overview')}>
                        {i18n.t('manage.account-overview')} <span><i className="fa fa-chevron-right"></i></span>
                    </Link>
                    {isAdmin &&
                        <Link href={route('manage.subscriptions.index')}>
                            {i18n.t('manage.subscriptions')} <span><i className="fa fa-chevron-right"></i></span>
                        </Link>
                    }
                    <Link href={route('manage.invoice.index')}>
                        {i18n.t('manage.invoices')} <span><i className="fa fa-chevron-right"></i></span>
                    </Link>
                    <Link href={route('manage.people.index')}>
                        {i18n.t('manage.people')} <span><i className="fa fa-chevron-right"></i></span>
                    </Link>
                </nav>
            </section>
            <section className={styles.contentWrap}>
                <div className={styles.contentTitleWrap}>
                    <button
                        className={`btn btn-toolbar ${styles.mobileNavOpenIcon}`}
                        onClick={() => {
                            setShowMobileNav(true)
                        }}
                    >
                        <i className={`fa fa-chevron-left`}></i>
                    </button>
                    <h1 className={styles.contentTitle}>{title}</h1>
                </div>
                <div className={styles.childrenWrap}>{children}</div>
            </section>
        </div>
    )
}
